import { render, staticRenderFns } from "./RollCard.vue?vue&type=template&id=5f341d5c&scoped=true&"
import script from "./RollCard.vue?vue&type=script&lang=js&"
export * from "./RollCard.vue?vue&type=script&lang=js&"
import style0 from "./RollCard.vue?vue&type=style&index=0&id=5f341d5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f341d5c",
  null
  
)

export default component.exports